import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Profile } from '@main-client/src/app/profile/profile';
import { isAdminOfGroup } from '@main-client/src/app/user/user.helpers';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-profile-intro-menu',
  templateUrl: './profile-intro-menu.component.html',
})
export class ProfileIntroMenuComponent implements OnInit {
  @Input() profile: Profile;
  @Input() user: Account;
  profileMenuItemLabels = {
    hub: {
      label: $localize`:@@profileView.intro.profileTab.label:Profile`,
    },
    profile: {
      label: $localize`:@@profileView.intro.hubTab.label:Hubs`,
    },
    scorecard: {
      label: $localize`:@@profileView.intro.scorecardTab.label:Scorecard`,
    },
  };
  canUserViewScoreCard = false;

  constructor(public readonly route: ActivatedRoute) {}

  ngOnInit() {
    const isAdminOfAnyGroups = this.profile.groups.some(
      (membership: AccountGroupMembership) =>
        isAdminOfGroup(this.user, membership.document),
    );
    this.canUserViewScoreCard =
      (this.user._id === this.profile._id ||
        this.user.isAdmin ||
        isAdminOfAnyGroups) &&
      !!this.profile.groups?.length;
  }
}
